import { Component, OnInit } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { QueryService } from '../_services/query.service';

@Component({
  selector: 'app-queries',
  host: { class: 'wrapper' },
  templateUrl: './queries.component.html',   
})
export class QueriesComponent implements OnInit {
  constructor(           
    private authService: AuthService,
    private router: Router,
    private queryService: QueryService,
    private route: ActivatedRoute
  ) {}

  async ngOnInit() {
    if (!this.authService.isLoggedIn()) {
      this.router.navigate(['/']);
    } else {
      await this.getQueries()
    }
  }

  getQueries() {
    this.route.paramMap.subscribe(params => {
      const idCompany = params.get('idCompany');
      const numDays = params.get('numDays');
  
      if (idCompany && numDays) {
        this.queryService.getByCompanyAndNumDays(idCompany, numDays).subscribe();
      } else if (numDays) {
        this.queryService.getByNumDays(numDays).subscribe();
      } else {
        this.queryService.getAll().subscribe();
      }
    });
  }
}
